import { Provider } from '@angular/core';
import { MaintenanceFirestoreStore } from './maintenance-firestore-store.service';
import { MaintenanceMockStore } from './maintenance-mock-store.service';
import { MAINTENANCE_STORE, resolveMaintenanceStoreMode } from './maintenance-store.interface';

export function provideMaintenanceStore(): Provider[] {
  return [
    MaintenanceMockStore,
    MaintenanceFirestoreStore,
    {
      provide: MAINTENANCE_STORE,
      useFactory: (mock: MaintenanceMockStore, firestore: MaintenanceFirestoreStore) =>
        resolveMaintenanceStoreMode() === 'mock' ? mock : firestore,
      deps: [MaintenanceMockStore, MaintenanceFirestoreStore]
    }
  ];
}
